<template>
  <div class="vimeo panel-settings">
  </div>
</template>

<script>
export default {
};
</script>
